import { useState } from "react";
import { Link } from "react-router-dom";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Checkbox } from "@/components/ui/checkbox";
import { Shield } from "lucide-react";

const TermsAgreementModal = ({ open, onAgree }) => {
  const [agreed, setAgreed] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleAgree = async () => {
    if (!agreed) return;
    setLoading(true);
    await onAgree();
    setLoading(false);
  };

  return (
    <Dialog open={open} onOpenChange={() => {}}>
      <DialogContent 
        className="sm:max-w-[425px] [&>button]:hidden" 
        onPointerDownOutside={(e) => e.preventDefault()} 
        onEscapeKeyDown={(e) => e.preventDefault()}
      >
        <DialogHeader>
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-full bg-forest/10 flex items-center justify-center shrink-0">
              <Shield className="w-5 h-5 text-forest" />
            </div>
            <DialogTitle className="font-display text-xl">Welcome to ProspectConnect</DialogTitle>
          </div>
        </DialogHeader>
        
        <div className="py-4">
          <p className="text-sm text-muted-foreground mb-4">
            By using ProspectConnect, you agree to our Privacy Policy and Terms of Service.
          </p>
          
          <div className="flex gap-4 text-sm mb-4">
            <Link 
              to="/privacy-policy" 
              target="_blank"
              className="text-forest hover:text-accent underline underline-offset-2"
            >
              Privacy Policy
            </Link>
            <Link 
              to="/terms-of-service" 
              target="_blank"
              className="text-forest hover:text-accent underline underline-offset-2"
            >
              Terms of Service
            </Link>
          </div>
          
          <div className="flex items-center gap-3 pt-4 border-t border-stone">
            <Checkbox 
              id="terms-agree" 
              checked={agreed}
              onCheckedChange={setAgreed}
            />
            <label 
              htmlFor="terms-agree" 
              className="text-sm cursor-pointer"
            >
              I agree to the Privacy Policy and Terms of Service
            </label>
          </div>
        </div>
        
        <DialogFooter>
          <Button 
            onClick={handleAgree} 
            disabled={!agreed || loading}
            className="w-full bg-forest hover:bg-forest/90"
            data-testid="terms-agree-btn"
          >
            {loading ? "Please wait..." : "Continue"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default TermsAgreementModal;
